var r={progressBar:"lds-progress-bar",ok:"lds-progress-bar--ok",caution:"lds-progress-bar--caution",danger:"lds-progress-bar--danger"};export{r as default};
